import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(2, 0),
    '& span': {
      margin: theme.spacing(0),
    },
  },

}));

export default useStyles;
